// extracted by mini-css-extract-plugin
export default {"suggestion-block":"styles-module__suggestion-block___PXP7M","basic":"styles-module__basic____QeX9","manage-wl-page":"styles-module__manage-wl-page___ebMHQ"};